
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/updates/multiple-memberships",
      function () {
        return require("private-next-pages/updates/multiple-memberships.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/updates/multiple-memberships"])
      });
    }
  